

import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Button, Container, Input, Row } from 'reactstrap';
// import { recentOrders } from '../../common/data';
import BreadCrumb from '../../Components/Common/BreadCrumb';
// import ClientList from './ClientList';
import Cards from './dashboard';

const Dashboard = () => {


    return (
        <React.Fragment>
            <div className='page-content'>
                <Container fluid>
                    <Col>
                        <BreadCrumb title="Dashboard" />
                        <Card>
                            <CardBody>
                                <Row>
                                    <Cards />
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Dashboard;